module.exports = __webpack_public_path__ + "static/media/training_2_mind_body_fitness.5e9e6764.webp";